module.exports = __webpack_public_path__ + "static/pakmaya-dijital-iletisim-formu-ca4034a196f1ebaa825edfaa7ba073e0.png";